import { Component } from 'react';
import { Modal, Button, Form, Row, Col, Accordion, Alert, InputGroup } from 'react-bootstrap';
import { FaSearch, FaEraser, FaExclamationTriangle, FaCheckCircle } from 'react-icons/fa';
import Paginacao from '../../common/pagination';
import faqAreasService from "../../api/faq/faqAreasService";
import programaFaqService from "../../api/faq/programaFaqService";

class SelecionarFaqModal extends Component {
    constructor(props) {
        super(props);
        this.faqPageLimit = 10;
        this.state = {
            busca: '',
            faqs: [],
            loading: false,
            error: null,
            page_numb: 1,
            total: 0,
            next: null,
            previous: null,
            selectedFaqIds: this.props.selectedFaqIds || [],
            selectedFaqMap: {},
            searchTimeout: null,
            allFaqAreas: [],
            selectedAreaId: 'all'
        };
    }

    componentDidMount() {
        this.carregarAreasGlobais();
    }

    componentWillUnmount() {
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            if (this.state.searchTimeout) {
                clearTimeout(this.state.searchTimeout);
            }

            this.setState({
                busca: '',
                page_numb: 1,
                selectedFaqIds: this.props.selectedFaqIds || [],
                selectedAreaId: 'all',
                faqs: [],
                total: 0,
                next: null,
                previous: null,
                selectedFaqMap: {},
                searchTimeout: null
            }, () => this.carregarFaqs(1));
        }
    }

    carregarAreasGlobais = async () => {
        try {
            const response = await faqAreasService.getAll({ ativo: true });
            this.setState({ allFaqAreas: response.data.results || [] });
        } catch (error) {
            console.error("Erro ao carregar áreas de FAQ:", error);
        }
    };

    carregarFaqs = (pagina = 1) => {
        const { programaId } = this.props;
        const { busca, selectedAreaId } = this.state;

        if (!programaId) return;

        this.setState({ loading: true, error: null });

        const params = {
            programa_id: programaId,
            page: pagina,
            limit: this.faqPageLimit
        };

        if (busca && busca.trim()) {
            params.search = busca.trim();
        }
        if (selectedAreaId && selectedAreaId !== 'all') {
            params.area_id = selectedAreaId;
        }

        programaFaqService.getAll(params)
            .then(response => {
                const responseData = response.data || {};
                const results = Array.isArray(responseData) ? responseData : (responseData.results || []);
                const selectedFaqMap = results.reduce((acc, faq) => {
                    acc[faq.id] = faq;
                    return acc;
                }, {});

                this.setState(prevState => ({
                    faqs: results,
                    total: responseData.count ?? results.length,
                    next: responseData.next || null,
                    previous: responseData.previous || null,
                    loading: false,
                    page_numb: pagina,
                    selectedFaqMap: { ...prevState.selectedFaqMap, ...selectedFaqMap }
                }));
            })
            .catch(error => {
                console.error("Erro ao carregar FAQs:", error);
                this.setState({
                    loading: false,
                    error: "Erro ao carregar FAQs. Tente novamente."
                });
            });
    };

    handleSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ busca: value });

        // Clear previous timeout
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }

        // Set new timeout for debounce
        const newTimeout = setTimeout(() => {
            this.carregarFaqs(1);
        }, 500);

        this.setState({ searchTimeout: newTimeout });
    };

    handleSearchSubmit = (e) => {
        e.preventDefault();
        this.carregarFaqs(1);
    };

    handleClearSearch = () => {
        this.setState({ busca: '' }, () => this.carregarFaqs(1));
    };

    handlePageChange = (pagina) => {
        this.carregarFaqs(pagina);
    };

    handleSelectFaq = (faqId) => {
        const { selectedFaqIds } = this.state;
        let newSelection = [...selectedFaqIds];

        if (newSelection.includes(faqId)) {
            newSelection = newSelection.filter(id => id !== faqId);
        } else {
            newSelection.push(faqId);
        }

        this.setState({ selectedFaqIds: newSelection });
    };

    handleConfirmVal = () => {
        const { faqs, selectedFaqIds, selectedFaqMap } = this.state;
        const selectedObjects = selectedFaqIds
            .map(id => selectedFaqMap[id] || faqs.find(f => f.id === id))
            .filter(Boolean);
        
        this.props.onSelect(selectedFaqIds, selectedObjects);
        this.props.onHide();
    };

    handleAreaSelect = (e) => {
        const areaId = e.target.value;
        this.setState({ selectedAreaId: areaId }, () => this.carregarFaqs(1));
    }

    render() {
        const { show, onHide } = this.props;
        const { faqs, loading, error, page_numb, total, busca, selectedFaqIds, allFaqAreas, selectedAreaId } = this.state;

        return (
            <Modal show={show} onHide={onHide} size="lg" scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>Consultar FAQ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={this.handleSearchSubmit} className="mb-3">
                        <Row>
                            <Col sm={4}>
                                <Form.Group className="mb-2">
                                    <Form.Control
                                        as="select"
                                        value={selectedAreaId}
                                        onChange={this.handleAreaSelect}
                                    >
                                        <option value="all">Todas as áreas</option>
                                        {allFaqAreas.map(area => (
                                            <option key={area.id} value={area.id}>{area.nome}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col sm={8}>
                                <InputGroup className="mb-2">
                                    <Form.Control
                                        type="text"
                                        placeholder="Buscar por pergunta ou resposta..."
                                        value={busca}
                                        onChange={this.handleSearchChange}
                                    />
                                    {busca && (
                                        <Button size="sm" variant="outline-secondary" onClick={this.handleClearSearch}>
                                            <FaEraser />
                                        </Button>
                                    )}
                                    <Button size="sm" variant="primary" type="submit">
                                        <FaSearch /> Buscar
                                    </Button>
                                </InputGroup>
                            </Col>
                        </Row>
                        
                    </Form>

                    {loading ? (
                        <div className="text-center py-3">
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Carregando FAQs...
                        </div>
                    ) : error ? (
                        <Alert variant="danger">{error}</Alert>
                    ) : faqs.length === 0 ? (
                        <Alert variant="warning" className="d-flex align-items-center gap-2 border-0" style={{ backgroundColor: '#fff3cd', color: '#7a4d00' }}>
                            <FaExclamationTriangle />
                            <span className="fw-semibold">Nenhuma FAQ encontrada para os filtros informados.</span>
                        </Alert>
                    ) : (
                        <>
                            <Accordion className="mb-3">
                                {faqs.map((faq, index) => {
                                    const isSelected = selectedFaqIds.includes(faq.id);
                                    return (
                                    <Accordion.Item eventKey={index.toString()} key={faq.id} className={isSelected ? 'border border-success' : ''}>
                                        <Accordion.Header>
                                            <div className="d-flex align-items-center w-100 justify-content-between me-3">
                                                <span>{faq.pergunta}</span>
                                                <div className="d-flex align-items-center">
                                                    {isSelected && (
                                                        <span className="badge bg-success ms-2 d-flex align-items-center">
                                                            <FaCheckCircle className="me-1" /> Selecionada
                                                        </span>
                                                    )}
                                                    {faq.dados_area && faq.dados_area.nome && (
                                                        <span className="badge bg-warning text-dark ms-2">{faq.dados_area.nome}</span>
                                                    )}
                                                </div>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <div style={{ overflowX: 'auto' }} dangerouslySetInnerHTML={{ __html: faq.resposta }} />
                                            {faq.dados_area && (
                                                 <div className="mt-2 text-muted small">
                                                     <strong>Área:</strong> {faq.dados_area.nome}
                                                 </div>
                                            )}
                                            <hr />
                                            <Form.Check 
                                                type="checkbox"
                                                id={`faq-checkbox-${faq.id}`}
                                                name={`faq-selection-${faq.id}`}
                                                label="Selecionar esta FAQ"
                                                checked={selectedFaqIds.includes(faq.id)}
                                                onChange={() => this.handleSelectFaq(faq.id)}
                                                className="fw-bold text-primary"
                                            />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    );
                                })}
                            </Accordion>

                            <Paginacao
                                dados={{ count: total, next: this.state.next, previous: this.state.previous }}
                                loading={loading}
                                limit={this.faqPageLimit}
                                page_numb={page_numb}
                                _onClickPagina={this.handlePageChange}
                            />
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant="light" onClick={onHide}>Cancelar</Button>
                    <Button 
                        size="sm"
                        variant="success" 
                        onClick={this.handleConfirmVal}
                    >
                        Confirmar Seleção ({selectedFaqIds.length})
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default SelecionarFaqModal;
